import service from '../utils/fetch';
import { stringify } from 'qs';

export async function queryStudentActivity(data) {
    return service('/zy/m/s/activity/winter/index', {
        method: 'POST',
        data: stringify(data),
    });
}

export async function addEnergy(data) {
    return service('/zy/m/s/activity/winter/addEnergy', {
        method: 'POST',
        data: stringify(data),
    });
}

export async function queryWinnerList(data) {
    return service('/zy/m/s/activity/winter/listStuLottery', {
        method: 'POST',
        data: stringify(data),
    });
}




// WEBPACK FOOTER //
// ./src/views/winter-camp/api/activity.js